import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tComments\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "float-end" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add Comment", -1 /* HOISTED */);
const _hoisted_9 = { class: "form-contents" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "clearfix" };
const _hoisted_12 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_13 = { class: "input-group top_search" };
const _hoisted_14 = { class: "input-group-btn" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_16 = [
    _hoisted_15
];
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_18 = { class: "input-group top_search" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_20 = { class: "input-group top_search" };
const _hoisted_21 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_22 = { class: "input-group top_search" };
const _hoisted_23 = { class: "clearfix" };
const _hoisted_24 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_25 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_26 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_27 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_29 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_31 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_32 = { class: "input-group top_search" };
const _hoisted_33 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_34 = { class: "input-group top_search" };
const _hoisted_35 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_36 = { class: "input-group top_search" };
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix top10" }, null, -1 /* HOISTED */);
const _hoisted_38 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_39 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_40 = { class: "float-end left5" };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* HOISTED */);
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix top10" }, [
    /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_43 = { class: "clearfix pad10" };
const _hoisted_44 = { class: "float-end" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_46 = { class: "float-end" };
const _hoisted_47 = { class: "float-end hidden-xs record-count" };
const _hoisted_48 = { class: "col-xs-12 col-sm-12" };
const _hoisted_49 = { class: "card bg-white data-grid comments-grid detached overflow-x-auto" };
const _hoisted_50 = { class: "table table-hover bottom0 pw100" };
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("th", { class: "text-center hidden-sm w40 no-min-width" }, null, -1 /* HOISTED */);
const _hoisted_52 = {
    key: 0,
    class: "date-time-column"
};
const _hoisted_53 = {
    key: 1,
    class: "hidden-sm"
};
const _hoisted_54 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_55 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_56 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_57 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_58 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_59 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_60 = ["onClick"];
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_62 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_64 = { key: 0 };
const _hoisted_65 = { class: "hidden-sm" };
const _hoisted_66 = { class: "visible-sm" };
const _hoisted_67 = { key: 0 };
const _hoisted_68 = ["title"];
const _hoisted_69 = {
    key: 2,
    class: "hidden-sm"
};
const _hoisted_70 = {
    key: 3,
    class: "hidden-sm"
};
const _hoisted_71 = {
    key: 4,
    class: "hidden-sm"
};
const _hoisted_72 = {
    key: 5,
    class: "hidden-sm"
};
const _hoisted_73 = {
    key: 6,
    class: "hidden-sm"
};
const _hoisted_74 = {
    key: 7,
    class: "hidden-sm"
};
const _hoisted_75 = { key: 0 };
const _hoisted_76 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center hidden-sm",
    colspan: "9"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_77 = /*#__PURE__*/ _createElementVNode("td", { class: "text-center visible-sm" }, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_router_link, { to: { name: 'comment' } }, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_button, { variant: "primary" }, {
                                    default: _withCtx(() => [
                                        _hoisted_7,
                                        _hoisted_8
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_b_form_input, {
                                    type: "text",
                                    modelValue: _ctx.query.keywords,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                    placeholder: "Search for...",
                                    onKeyup: _withKeys(_ctx.search, ["enter"]),
                                    required: "",
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "onKeyup", "disabled"]),
                                _createTextVNode(),
                                _createElementVNode("span", _hoisted_14, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-default",
                                        onClick: _cache[1] || (_cache[1] =
                                            //@ts-ignore
                                            (...args) => (_ctx.search && _ctx.search(...args))),
                                        style: { "height": "34px" }
                                    }, _hoisted_16)
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.companyId,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.companyId) = $event)),
                                    options: _ctx.companies,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any company",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("No results found")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.siteId,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.siteId) = $event)),
                                    options: _ctx.filteredSites,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any site",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("No results found")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createVNode(_component_multiselect, {
                                    name: "logType",
                                    modelValue: _ctx.logTypeId,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.logTypeId) = $event)),
                                    options: _ctx.logTypes,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any type",
                                    class: "multiselect-small",
                                    disabled: _ctx.working
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("No results found")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                            (!_ctx.showDatePickers)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                        return _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                            class: "pw100",
                                            disabled: _ctx.working,
                                            key: idx,
                                            variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                            onClick: ($event) => (_ctx.setDateFilterOption(item)),
                                            title: _ctx.getPeriodTitle(item)
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick", "title"])), [
                                            [
                                                _directive_b_tooltip,
                                                void 0,
                                                void 0,
                                                { hover: true }
                                            ]
                                        ]);
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (_ctx.showDatePickers)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_b_input_group, {
                                            class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_flat_pickr, {
                                                    class: "form-control",
                                                    modelValue: _ctx.query.startTime,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.query.startTime) = $event)),
                                                    config: _ctx.datePickerConfig,
                                                    placeholder: "From date",
                                                    disabled: _ctx.working
                                                }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                _createTextVNode(),
                                                _createVNode(_component_b_input_group_append, null, {
                                                    default: _withCtx(() => [
                                                        _hoisted_28
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["class"])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_b_input_group, {
                                            class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_flat_pickr, {
                                                    class: "form-control",
                                                    modelValue: _ctx.query.endTime,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.endTime) = $event)),
                                                    config: _ctx.datePickerConfig,
                                                    placeholder: "Until date",
                                                    disabled: _ctx.working
                                                }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                                _createTextVNode(),
                                                _createVNode(_component_b_input_group_append, null, {
                                                    default: _withCtx(() => [
                                                        _hoisted_30,
                                                        _createTextVNode(),
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-secondary",
                                                            onClick: _cache[7] || (_cache[7] =
                                                                //@ts-ignore
                                                                (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                        }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["class"])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_multiselect, {
                                    name: "system",
                                    modelValue: _ctx.system,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.system) = $event)),
                                    options: _ctx.filteredSystems,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any system",
                                    class: "multiselect-small",
                                    disabled: _ctx.working
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("No results found")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                                _createVNode(_component_multiselect, {
                                    name: "component",
                                    modelValue: _ctx.component,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.component) = $event)),
                                    options: _ctx.systemComponents,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any location",
                                    class: "multiselect-small",
                                    disabled: _ctx.working
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("No results found")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                _createVNode(_component_multiselect, {
                                    name: "author",
                                    modelValue: _ctx.authorId,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.authorId) = $event)),
                                    options: _ctx.users,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Any author",
                                    class: "multiselect-small",
                                    disabled: _ctx.working
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("No results found")
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options", "disabled"])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _hoisted_37,
                    _createTextVNode(),
                    (_ctx.searchAttempted)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                    _createVNode(_component_b_dropdown, {
                                        ref: "columnSettingsDropdown",
                                        "no-caret": "",
                                        end: "",
                                        sm: "",
                                        "auto-close": false,
                                        variant: "outline-secondary outline-secondary-pagination",
                                        disabled: _ctx.working
                                    }, {
                                        "button-content": _withCtx(() => [
                                            _hoisted_41
                                        ]),
                                        default: _withCtx(() => [
                                            _createTextVNode(),
                                            _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_form_group, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_form_checkbox, {
                                                                id: "includeDeleted",
                                                                modelValue: _ctx.query.includeDeleted,
                                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.query.includeDeleted) = $event))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\tShow archived\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["modelValue"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }),
                                                    _createTextVNode(),
                                                    _hoisted_42,
                                                    _createTextVNode(),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIdx) => {
                                                        return (_openBlock(), _createBlock(_component_b_form_group, {
                                                            key: column.fieldName
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_form_group, null, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_b_form_checkbox, {
                                                                            id: column.fieldName,
                                                                            modelValue: column.visible,
                                                                            "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                            ]),
                                                                            _: 2 /* DYNAMIC */
                                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1024 /* DYNAMIC_SLOTS */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1024 /* DYNAMIC_SLOTS */));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _createTextVNode(),
                                            _createVNode(_component_b_dropdown_divider),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_43, [
                                                _createElementVNode("div", _hoisted_44, [
                                                    _createVNode(_component_b_button, {
                                                        variant: "secondary",
                                                        right: "",
                                                        sm: "",
                                                        onClick: _ctx.closeColumnSettingsMenu
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_45,
                                                            _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t")
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["onClick"])
                                                ])
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["disabled"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_46, [
                                    _createVNode(_component_b_pagination, {
                                        class: "float-end",
                                        modelValue: _ctx.query.pageNo,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.query.pageNo) = $event)),
                                        "per-page": _ctx.query.pageSize,
                                        "total-rows": _ctx.data.recordCount,
                                        "hide-ellipsis": true,
                                        disabled: _ctx.working
                                    }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_47, "\r\n\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("table", _hoisted_50, [
                                _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _hoisted_51,
                                        _createTextVNode(),
                                        (_ctx.isVisible('date'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_52, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'WhenEntered', title: 'Date' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('note'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_53, "\r\n\t\t\t\t\t\t\t\t\t\t\tNote\r\n\t\t\t\t\t\t\t\t\t\t"))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('type'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_54, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'LogTypeName', title: 'Type' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('location'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_55, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'ComponentName', title: 'Location' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('system'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_56, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'SystemName', title: 'System' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('site'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_57, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'SiteName', title: 'Site' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('company'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_58, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'CompanyName', title: 'Company' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isVisible('author'))
                                            ? (_openBlock(), _createElementBlock("th", _hoisted_59, [
                                                _createVNode(_component_SortableColumnComponent, {
                                                    sorter: _ctx.sorter,
                                                    column: { fieldName: 'FirstName', title: 'Author' }
                                                }, null, 8 /* PROPS */, ["sorter"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            class: _normalizeClass(['pointer', { 'deleted': item.whenDeleted }]),
                                            onClick: ($event) => (_ctx.edit(item))
                                        }, [
                                            _createElementVNode("td", {
                                                class: "text-center hidden-sm",
                                                onClick: _cache[13] || (_cache[13] = _withModifiers(() => { }, ["stop"]))
                                            }, [
                                                _createVNode(_component_b_button_group, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_b_dropdown, {
                                                            variant: "outline-secondary dots",
                                                            size: "sm",
                                                            onClick: ($event) => (_ctx.edit(item))
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_b_dropdown_item, {
                                                                    onClick: ($event) => (_ctx.edit(item))
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _hoisted_61,
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                                _createTextVNode(),
                                                                _createVNode(_component_b_dropdown_divider),
                                                                _createTextVNode(),
                                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                    onClick: ($event) => (_ctx.archive(item))
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _hoisted_62,
                                                                        _createTextVNode(" Archive\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                    [_vShow, !item.whenDeleted]
                                                                ]),
                                                                _createTextVNode(),
                                                                _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                    onClick: ($event) => (_ctx.restore(item))
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _hoisted_63,
                                                                        _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                    [_vShow, item.whenDeleted]
                                                                ])
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */)
                                            ]),
                                            _createTextVNode(),
                                            (_ctx.isVisible('date'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_64, [
                                                    _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.getFormattedDate(item.whenEntered)), 1 /* TEXT */),
                                                    _createTextVNode(),
                                                    _createElementVNode("div", _hoisted_66, [
                                                        _createVNode(_component_router_link, {
                                                            to: { name: 'comment', params: { 'id': item.logId } },
                                                            class: "lead"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("b", null, _toDisplayString(_ctx.getFormattedDate(item.whenEntered)) + " | " + _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                        _createTextVNode(),
                                                        _createElementVNode("p", null, [
                                                            _createTextVNode(_toDisplayString(item.systemName), 1 /* TEXT */),
                                                            (item.componentName)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_67, ": " + _toDisplayString(item.componentName), 1 /* TEXT */))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _createTextVNode(),
                                                        _createElementVNode("p", null, _toDisplayString(item.notes), 1 /* TEXT */)
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('note'))
                                                ? (_openBlock(), _createElementBlock("td", {
                                                    key: 1,
                                                    class: "large-text-ellipsis hidden-sm",
                                                    title: item.notes
                                                }, _toDisplayString(item.notes), 9 /* TEXT, PROPS */, _hoisted_68))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('type'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_69, _toDisplayString(item.logTypeName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('location'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_70, _toDisplayString(item.componentName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('system'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_71, _toDisplayString(item.systemName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('site'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_72, _toDisplayString(item.siteName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('company'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_73, _toDisplayString(item.companyName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true),
                                            _createTextVNode(),
                                            (_ctx.isVisible('author'))
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_74, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ], 10 /* CLASS, PROPS */, _hoisted_60));
                                    }), 256 /* UNKEYED_FRAGMENT */))
                                ]),
                                _createTextVNode(),
                                _createElementVNode("tfoot", null, [
                                    (_ctx.noData)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_75, [
                                            _hoisted_76,
                                            _createTextVNode(),
                                            _hoisted_77
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.searchAttempted]
                    ])
                ])
            ])
        ])
    ]));
}
